import { matchValues } from '@shared/core/types/common';

const locale: OLO.Types.COUNTRIES_CODE[] = ['en-AU', 'pl-PL', 'en-US', 'en-NZ', 'es-US'];

export const localeType = matchValues(...locale);
